import React from "react";
import styled from "styled-components";
import { Section, Typography } from "../../../core";
import { Row, Col } from "antd";

const FIXED_TO = require("../../../helper/utils/Fixed");
const BAG_REQUIRED = require("../../../helper/utils/BagRequired");

const StyledTable = styled.table`
  margin: 20px 0px;
  width: 100%;
  thead {
    background: #233b67;
    color: white;
  }
  th,
  td {
    height: 50px;
    text-align: center;
    border: 1px solid #233b67;
    font-weight: 500;
    font-size: 16px;
  }
  .bt-0 {
    border-top: 0px;
  }
  .br-0 {
    border-right: 0px;
  }
  .bl-0 {
    border-left: 0px;
  }
  .bg-white {
    background-color: white;
  }
  .cl-blue {
    color: #233b67;
  }
`;

export const Calculations = ({ activeContract }) => {
  const {
    weftweight,
    weftRate,
    quantity,
    warpweight,
    warpRate,
    totalWeight,
    conversionRate,
    fabricRatePerMeter,
  } = activeContract;

  const WeftNet = FIXED_TO.multiRoundOff(weftweight, weftRate);
  const WrapNet = FIXED_TO.multiRoundOff(warpweight, warpRate);
  const TotalNet = FIXED_TO.addRoundOff(WeftNet, WrapNet);

  const WeftBagRequired = BAG_REQUIRED.BagRequired(weftweight, quantity);
  const WrapBagRequired = BAG_REQUIRED.BagRequired(warpweight, quantity);
  const TotalBagRequired = FIXED_TO.addRoundOff(
    WeftBagRequired,
    WrapBagRequired
  );

  return (
    <Row type="flex" justify="center" gutter={[16, 16]}>
      <Col md={16} xs={24}>
        <Section padding="20px">
          <Typography
            as="h3"
            weight="bold"
            color="#233B67"
            text="Calculations"
          />
          <StyledTable>
            <thead className="bg-white cl-blue">
              <tr>
                <td className="bt-0 bl-0"></td>
                <td className="bt-0">
                  <b>Warp</b>
                </td>
                <td className="bt-0">
                  <b>Weft</b>
                </td>
                <td className="bt-0 br-0">
                  <b>Total</b>
                </td>
              </tr>
            </thead>
            <tbody className="cl-blue">
              <tr>
                <td className="bl-0">
                  <b>Weight</b>
                </td>
                <td>{FIXED_TO.round_of_four(warpweight)}</td>
                <td>{FIXED_TO.round_of_four(weftweight)}</td>
                <td className="br-0">{FIXED_TO.round_of_four(totalWeight)}</td>
              </tr>
              <tr>
                <td className="bl-0">
                  <b>Rate</b>
                </td>
                <td>{FIXED_TO.round_of_four(warpRate)}</td>
                <td>{FIXED_TO.round_of_four(weftRate)}</td>
                <td className="br-0"></td>
              </tr>
              <tr>
                <td className="bl-0">
                  <b>Net</b>
                </td>
                <td>{WrapNet}</td>
                <td>{WeftNet}</td>
                <td className="br-0">{TotalNet}</td>
              </tr>
              <tr>
                <td className="bl-0">
                  <b>Bags</b>
                </td>
                <td>{WrapBagRequired}</td>
                <td>{WeftBagRequired}</td>
                <td className="br-0">{TotalBagRequired}</td>
              </tr>
              <tr>
                <td className="bl-0">
                  <b>Conversion Rate/m</b>
                </td>
                <td colspan={3} className="br-0">
                  {FIXED_TO.round_of_four(conversionRate)}
                </td>
              </tr>
              <tr>
                <td className="bl-0">
                  <b>Rate/MTR</b>
                </td>
                <td colspan={3} className="br-0">
                  {FIXED_TO.round_of_four(fabricRatePerMeter)}
                </td>
              </tr>
            </tbody>
          </StyledTable>
        </Section>
      </Col>
    </Row>
  );
};
